export enum NotificationType {
  TODO = 'todo',
  DONE = 'done',
  DONE_AUTO = 'done_auto',
}

export const notificationTypeAsString = (type: NotificationType | string, days = 0): string => {
  switch (type) {
    case NotificationType.TODO:
      return '🟡 Qualification en attente de réponse';
    case NotificationType.DONE:
      if(days === 0) 
        return '🛑 Suivi clôturé';
      return `📅 Suivi dans ${days} jours`;
    case NotificationType.DONE_AUTO:
      return '🤖 Suivi clôturé automatiquement';
    default:
      return `❌ Type "${type}" non reconnu`;
  }
};